import React from 'react';

// Renders a single-colour SVG icon (imported as a URL) tinted with the active
// brand colour via a CSS mask, so `<img>`-based icons follow the client theme
// (see utils/applyTheme). Forwards className/style so existing sizing CSS keeps
// working; falls back to `size` when the icon was sized by width/height attrs.
//
// NOTE: only for single-colour icons. Multi-colour SVGs would render as a solid
// silhouette — leave those as <img> (or handle per-colour separately).
export default function ThemedIcon({
  src,
  alt = '',
  color = 'var(--primary-button)',
  size,
  width,
  height,
  className,
  style,
  ...rest
}) {
  const mask = `url(${src}) center / contain no-repeat`;
  // A mask <span> with no dimensions renders as 0×0 (invisible). If the icon
  // isn't sized by className or inline style, fall back to a sane default.
  const externallySized =
    className || (style && (style.width || style.height));
  const fallback = externallySized ? undefined : '20px';
  return (
    <span
      role="img"
      aria-label={alt || undefined}
      className={className}
      style={{
        display: 'inline-block',
        backgroundColor: color,
        WebkitMask: mask,
        mask,
        width: width ?? size ?? fallback,
        height: height ?? size ?? fallback,
        ...style,
      }}
      {...rest}
    />
  );
}
